import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FadeUp, MaskedLine } from "./Reveal";

export default function QuoteCTA({
  title = "HAI GIÀ UNA DESTINAZIONE?",
  text = "Raccontaci dove devi andare e quando. Ti risponderemo con una soluzione personalizzata.",
  button = "Richiedi il tuo preventivo",
  to = "/richiedi-preventivo",
  testid = "cta-preventivo-button",
}) {
  return (
    <section className="relative isolate bg-coal" data-testid="cta-section">
      <div className="hairline" />
      <div className="grid-gold-hairline pointer-events-none absolute inset-0 -z-10" />
      <div className="pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(circle_at_50%_35%,rgba(198,169,107,0.06),transparent_70%)]" />
      <div className="mx-auto max-w-7xl px-6 py-24 md:py-32">
        <FadeUp>
          <MaskedLine>
            <h2 className="font-serif text-4xl leading-[1.05] text-bone sm:text-5xl lg:text-6xl">
              {title}
            </h2>
          </MaskedLine>
        </FadeUp>
        <FadeUp delay={0.15}>
          <p className="mt-8 max-w-xl text-[15px] font-light leading-relaxed text-mute">{text}</p>
          <Link data-testid={testid} to={to} className="btn-solid group mt-10">
            {button}
            <ArrowRight
              size={15}
              className="transition-transform duration-300 group-hover:translate-x-1"
            />
          </Link>
        </FadeUp>
      </div>
      <div className="hairline" />
    </section>
  );
}
